import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TransformationService } from '../../services/TransformationService';

@Directive({
  selector: '[appTransformAmountIfNumber]',
  standalone: false
})
export class TransformAmountIfNumberDirective {
  @Input() transformWithDecimals = false;

  constructor(private control: NgControl, private transformationService:TransformationService) {}

  @HostListener('blur')
  onBlur() {
    const currentValue = this.control.control?.value;
    if (currentValue !== null && currentValue !== undefined && currentValue !== '') {
      const transformed = this.transformationService.transformAmountIfNumber(currentValue, this.transformWithDecimals);
      
      if (transformed !== currentValue) {
        this.control.control?.setValue(transformed);
      }
    }
  }
}